import React from 'react'
import PropTypes from 'prop-types'
import { constants } from 'common/helpers'
import { FormattedHTMLMessage } from 'sb-react-intl'

import Button from 'components/buttons/Button/Button'
import Modal from 'components/modal/Modal/Modal'

import useRefund from 'components/modals/cancelSubscription/util/useRefund'

import messages from './messages'
import s from './RefundModal.scss'


const RefundModal = ({ name, data: { type, status, transactionType } }) => {
  const { chooseReceive, chooseRefund, isBillingDay1stEnabled } = useRefund(name, type, transactionType)

  let subTitleMessage = messages.subTitle

  if (status === 'AVAILABLE') {
    subTitleMessage = isBillingDay1stEnabled
      ? messages.subTitleForNotChargedUser1st
      : messages.subTitleForNotChargedUser
  }

  const receiveButtonMessage = status === 'AVAILABLE' ? messages.receiveButtonForNotChargedUser : messages.receiveButton

  return (
    <Modal
      className={s.refundModal}
      name={name}
      title={messages.title}
      onClose={chooseReceive}
    >
      <FormattedHTMLMessage className={s.subTitle} tag="div" {...subTitleMessage} />
      <FormattedHTMLMessage className={s.text} tag="div" {...messages.text} />
      <div className={s.buttons}>
        <Button
          className={s.refundButton}
          title={messages.refundButton}
          md
          gray
          dataTestId={constants.testIds.cancelSubscription.refundButton}
          onClick={chooseRefund} />
        <Button
          className={s.receiveButton}
          title={receiveButtonMessage}
          md
          brand
          dataTestId={constants.testIds.cancelSubscription.receiveButton}
          onClick={chooseReceive} />
      </div>
    </Modal>
  )
}

RefundModal.propTypes = {
  name: PropTypes.string.isRequired,
  data: PropTypes.shape({
    type: PropTypes.string,
    status: PropTypes.string,
    transactionType: PropTypes.oneOf([ 'PAUSE', 'SKIP', 'UNSUBSCRIBE' ]),
  }),
}

RefundModal.defaultProps = {
  name: constants.modals.cancelSubscription.Refund,
  data: {
    type: 'NEW_SUBSCRIBER',
    status: 'AVAILABLE',
  },
}


export default RefundModal
